export const CEP_FUNDS_DUE_REPORT_SET_SELECTED_SITES =
  'CEP_FUNDS_DUE_REPORT_SET_SELECTED_SITES';
export const CEP_FUNDS_DUE_REPORT_LOADING = 'CEP_FUNDS_DUE_REPORT_LOADING';
export const CEP_FUNDS_DUE_REPORT_GET_REPORT =
  'CEP_FUNDS_DUE_REPORT_GET_REPORT';
export const CEP_FUNDS_DUE_REPORT_ERROR = 'CEP_FUNDS_DUE_REPORT_ERROR';
export const CEP_FUNDS_DUE_REPORT_CLEAR_REPORT =
  'CEP_FUNDS_DUE_REPORT_CLEAR_REPORT';

export const CEP_FUNDS_DUE_REPORT_GET_SITES = 'CEP_FUNDS_DUE_REPORT_GET_SITES';



// WEBPACK FOOTER //
// ./src/pages/cepfundsdue/state/report/types.js